import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-carousel',
  imports: [],
  standalone: true,
  templateUrl: './custom-carousel.component.html',
})
export class CustomCarouselComponent {
  @Input() images: string[];

  protected activeIndex = 0;
  private startX = 0;
  private endX = 0;
  private swipeThreshold = 50;
  protected dragging = false;
  private hasMoved = false;

  ngOnInit() {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  ngOnDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('touchmove', this.onTouchMove);
    window.removeEventListener('touchend', this.onTouchEnd);
  }

  protected setActiveIndex(index: number) {
    this.activeIndex = index;
  }

  protected onStart(event: MouseEvent | TouchEvent) {
    const point = this.getPoint(event);
    this.startX = point.clientX;
    this.dragging = true;
    this.hasMoved = false;

    if (event instanceof MouseEvent) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    } else {
      window.addEventListener('touchmove', this.onTouchMove, { passive: false });
      window.addEventListener('touchend', this.onTouchEnd);
    }
  }

  private onMouseMove(event: MouseEvent) {
    const dx = Math.abs(event.clientX - this.startX);
    if (dx > 5) {
      this.hasMoved = true;
    }
  }

  private onMouseUp(event: MouseEvent) {
    this.endSwipe(event);
  }

  private onTouchMove(event: TouchEvent) {
    if (event.cancelable) event.preventDefault();
    const dx = Math.abs(event.touches[0].clientX - this.startX);
    if (dx > 5) {
      this.hasMoved = true;
    }
  }

  private onTouchEnd(event: TouchEvent) {
    this.endSwipe(event);
  }

  private endSwipe(event: MouseEvent | TouchEvent) {
    const point = this.getPoint(event);
    this.endX = point.clientX;

    if (this.hasMoved) {
      this.handleSwipe();
    }

    this.dragging = false;
    this.hasMoved = false;

    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('touchmove', this.onTouchMove);
    window.removeEventListener('touchend', this.onTouchEnd);
  }

  private getPoint(event: MouseEvent | TouchEvent): { clientX: number } {
    return event instanceof TouchEvent ? event.changedTouches[0] : event;
  }

  private handleSwipe() {
    const distance = this.startX - this.endX;
    if (Math.abs(distance) > this.swipeThreshold) {
      if (distance > 0) {
        this.activeIndex = (this.activeIndex + 1) % this.images.length;
      } else {
        this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;
      }
    }
  }
}
